export const productsIndex_AU = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_AU || '';
export const productsIndex_NZ = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_NZ || '';

export const productsQuerySuggestionsIndex_AU =
  process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_QUERY_SUGGESTIONS_INDEX_AU || '';
export const productsQuerySuggestionsIndex_NZ =
  process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_QUERY_SUGGESTIONS_INDEX_NZ || '';
